import React, { useEffect, useState } from 'react';
import { Box, IconButton, List, ListItem, ListItemButton } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { Icon } from 'src/mtska-frontend-app-component/assets';

const ComponentSlider = ({ report, maxWidth = '100%', height = 'auto', showTopPagination = false }) => {
    const [activeSection, setActiveSection] = useState(0);
    const [activeStep, setActiveStep] = useState(0);
    const [maxSteps, setMaxSteps] = useState(0);

    const [activeSectionStep, setActiveSectionStep] = useState(0);
    const [maxSectionStep, setMaxSectionStep] = useState(0);

    /** Accordion: solo un primo livello aperto; `null` = tutti chiusi. */
    const [expandedSectionIndex, setExpandedSectionIndex] = useState(null);

    useEffect(() => {
        setMaxSteps(report.reduce((total, section) => total + section.pages.length, 0));
    }, [report]);

    useEffect(() => {
        setMaxSectionStep(report[activeSection].pages.length);
    }, [activeSection]);

    useEffect(() => {
        let previousPages = 0;
        for (let i = 0; i < activeSection; i++) {
            previousPages += report[i].pages.length;
        }
        setActiveStep(previousPages + activeSectionStep);
    }, [activeSection, activeSectionStep]);

    const handleNext = () => {
        const currentSection = report[activeSection];
        const nextPageIndex = activeSectionStep + 1;

        if (nextPageIndex < currentSection.pages.length) {
            setActiveSectionStep(nextPageIndex);
            setExpandedSectionIndex(activeSection);
        } else {
            const nextSectionIndex = activeSection + 1;
            if (nextSectionIndex < report.length) {
                setActiveSection(nextSectionIndex);
                setActiveSectionStep(0);
                setExpandedSectionIndex(nextSectionIndex);
            } else {
                setActiveSection(0);
                setActiveSectionStep(0);
                setExpandedSectionIndex(0);
            }
        }
    };

    const handleBack = () => {
        if (activeSectionStep > 0) {
            setActiveSectionStep(activeSectionStep - 1);
            setExpandedSectionIndex(activeSection);
        } else {
            const prevSectionIndex = activeSection - 1;
            if (prevSectionIndex >= 0) {
                const lastPage = report[prevSectionIndex].pages.length - 1;
                setActiveSection(prevSectionIndex);
                setActiveSectionStep(lastPage);
                setExpandedSectionIndex(prevSectionIndex);
            } else {
                const lastSectionIndex = report.length - 1;
                const lastPage = report[lastSectionIndex].pages.length - 1;
                setActiveSection(lastSectionIndex);
                setActiveSectionStep(lastPage);
                setExpandedSectionIndex(lastSectionIndex);
            }
        }
    };

    const toggleSection = (index) => {
        setExpandedSectionIndex((prev) => (prev === index ? null : index));
    };

    const goTo = (section, page) => {
        setActiveSection(section);
        setActiveSectionStep(page);
        setExpandedSectionIndex(section);
    };

    return (
        <Box className={'mtska-slider'} sx={{ maxWidth: maxWidth, position: 'relative' }}>
            <List className="mtska-slider-page-index">
                {report.map((section, index) => (
                    <React.Fragment key={index}>
                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => toggleSection(index)}
                                selected={expandedSectionIndex === index}
                                className="mtska-slider-section-header"
                            >
                                <Icon icon={section.icon} className="icon" />
                                {section.title}
                            </ListItemButton>
                        </ListItem>
                        {expandedSectionIndex === index && (
                            <List disablePadding>
                                {section.pages.map((page, pageIndex) => (
                                    <ListItem
                                        key={pageIndex}
                                        sx={{ pl: 4, cursor: 'pointer' }}
                                        onClick={() => goTo(index, pageIndex)}
                                        className={'active' + (pageIndex === activeSectionStep && index === activeSection ? ' current' : '')}
                                    >
                                        <Icon icon={page.icon} className="icon" />
                                        {page.title}
                                    </ListItem>
                                ))}
                            </List>
                        )}
                    </React.Fragment>
                ))}
            </List>

            <Box sx={{ height: height, width: '100%' }} className="mtska-slider-page-wrapper">
                {report[activeSection].pages[activeSectionStep].component}
            </Box>

            <Box className="mtska-slider-pager">
                <IconButton
                    size="small"
                    onClick={handleBack}
                    disabled={maxSectionStep === 0}
                    className='slider-arrow slider-arrow-left'
                >
                    <KeyboardArrowLeft />
                </IconButton>
                <Box className="mtska-page-indicator">
                    {activeStep + 1} / {maxSteps}
                </Box>
                <IconButton
                    size="small"
                    onClick={handleNext}
                    disabled={maxSectionStep === 0}
                    className='slider-arrow slider-arrow-right'
                >
                    <KeyboardArrowRight />
                </IconButton>
            </Box>
        </Box>
    );
};

export default ComponentSlider;